import request from '@/system/engine/request';
import config from '@/system/engine/config';
import {getLocalStorage} from '@/system/store/localstorage';

// get language list
export function languageList(){
	const data = request({
		url: config.url+'language/getDataList',
		method: 'get',
	});

	return Promise.resolve(data);
}

// news
export function newsAjaxTable(limit,pagination,id,title,content,created_at){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'site_news/ajaxTable?language=' + language +'&limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&title=' + title + '&content=' + content + '&created_at=' + created_at,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function newsAdd(postData){
	const data = request({
		url: config.url+'site_news/add',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function getNewsEdit(id){
	const data = request({
		url: config.url+'site_news/edit?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

export function newsEdit(postData){
	const data = request({
		url: config.url+'site_news/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function newsDelete(postData){
	const data = request({
		url: config.url+'site_news/delete',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}

export function newsInfo(id){
	const data = request({
		url: config.url+'site_news/info?id=' + id,
		method: 'get',
	});

	return Promise.resolve(data);
}

// pool
export function poolAjaxTable(limit,pagination,code,value){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'site_pool/ajaxTable?language=' + language +'&limit=' + limit + '&pagination=' + pagination + '&code=' + code + '&value=' + value,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function getPoolEdit(code){
	const data = request({
		url: config.url+'site_pool/edit?code='+code,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function poolEdit(postData){
	const data = request({
		url: config.url+'site_pool/edit',
		method: 'post',
		data: postData,
	});

	return Promise.resolve(data);
}
